module.exports = {"620171101":"中川镇","620171102":"秦川镇","620171103":"西岔镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620171.json
// module id = 2898
// module chunks = 0